/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DiamondEmptyIcon
 */
export default class DiamondEmptyIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.776 4h-7.5c-.565 0-1.114.136-1.603.388-.464.24-.82.606-1.197 1.012L1.92 9.092a3 3 0 00.279 3.92l7.679 7.681a3 3 0 003.961.249l.097-.08.094-.083.054-.121.036.036 7.68-7.68a3 3 0 00.279-3.921L18.576 5.4c-.751-.73-1.699-1.4-2.8-1.4zm0 2a1.5 1.5 0 011.1.48l.1.12 3.503 3.693a1 1 0 01-.012 1.215l-.081.092-7.68 7.68-.094.083a1 1 0 01-1.226 0l-.094-.084-7.679-7.68a1 1 0 01-.16-1.205l.067-.102L7.076 6.6a1.5 1.5 0 011.044-.592L8.276 6h7.5z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

